import React from 'react';
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb';

const BlogDetailsBreadcrumb = () => {
    return (
        <>
            <Breadcrumb title="Blog" subTitle="Details" smText='Blog Details'></Breadcrumb>
        </>
    );
};

export default BlogDetailsBreadcrumb;